import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {TradeContractFormatState} from "./model";

let state: TradeContractFormatState = {
  formats: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<TradeContractFormatState, RootStateType>;
